import _ from '../../core/utils'
import SCROLLTO_CONFIG from './config'

class ScrolltoClass {
    constructor( el ) {
        this.DOM = {
            el: el
        }
        this.destination = _.select( this.DOM.el.getAttribute( 'href' ) )
        this.init()
    }

    init() {
        this._listeners()
        console.log( this )
    }

    _listeners() {
        this.DOM.el.addEventListener( 'click', this._scrollto.bind( this ) )
    }

    _scrollto() {
        event.preventDefault()
        this.destination.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
}

const SCROLLTOS = []
SCROLLTO_CONFIG.scrolltos.forEach( ( scrollto ) => {  SCROLLTOS.push( new ScrolltoClass( scrollto ) ) })
export default SCROLLTOS
